import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

import {MatTooltipModule} from '@angular/material/tooltip';
import {DxDataGridModule, DxTreeViewModule, DxListModule, DxContextMenuModule, DxTemplateModule, DxCheckBoxModule, DxSelectBoxModule, DxValidationSummaryModule, DxButtonModule, DxValidatorModule, DxBulletModule, DxLoadPanelModule, DxSortableModule, DxTabPanelModule, DxHtmlEditorModule} from 'devextreme-angular';

import {ComponentesModule} from '@componentes/Componentes.module';

import { GlobalModule } from '../global/global.module';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PipesModule } from '@pipes/Pipes.module';
import { AcuerdoRoutingModule } from './acuerdo-routing.module';
import { AcuerdoPendienteComponent } from './acuerdopendiente/acuerdopendiente.component';
import { ConsultaAcuerdoComponent } from './consultaacuerdo/consultaacuerdo.component';
import { ConsultaAcuerdoDetalleComponent } from './consultaacuerdo/consultaacuerdodetalle.component';
import { ConsultaAcuerdoAcuerdoComponent } from './consultaacuerdo/seccion/consultaacuerdo_acuerdo.component';
import { ConsultaAcuerdoGeneralComponent } from './consultaacuerdo/seccion/consultaacuerdo_general.component';
import { AcuerdoPendienteDetalleComponent } from './acuerdopendiente/acuerdopendientedetalle.component';
import { ConsultaAcuerdoAlumnoComponent } from './consultaacuerdo/seccion/consultaacuerdo_alumno.component';
import { ConsultaAcuerdoPadreComponent } from './consultaacuerdo/seccion/consultaacuerdo_padre.component';
import { ConsultaAcuerdoAlumnoTallerComponent } from './consultaacuerdo/seccion/consultaacuerdo_alumnotaller.component';
import { ConsultaAcuerdoPadreTallerComponent } from './consultaacuerdo/seccion/consultaacuerdo_padretaller.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentesModule,
        TranslateModule,
        FormsModule,
        MatTooltipModule,
        MatTabsModule,
        DxDataGridModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxValidationSummaryModule,
        DxButtonModule,
        DxValidatorModule,
        DxBulletModule,
        DxLoadPanelModule,
        DxTreeViewModule,
        DxListModule,
        AngularSvgIconModule,
        DxContextMenuModule,
        DxTemplateModule,
        PipesModule,
        GlobalModule,
        AcuerdoRoutingModule,
        DxSortableModule,
        DxHtmlEditorModule,
        DxTabPanelModule,
    ],
    declarations: [
        AcuerdoPendienteComponent,
        ConsultaAcuerdoComponent,
        AcuerdoPendienteDetalleComponent,
        ConsultaAcuerdoDetalleComponent,
        ConsultaAcuerdoAcuerdoComponent,
        ConsultaAcuerdoGeneralComponent,
        ConsultaAcuerdoAlumnoComponent,
        ConsultaAcuerdoAlumnoTallerComponent,
        ConsultaAcuerdoPadreTallerComponent,
        ConsultaAcuerdoPadreComponent,
    ],
    entryComponents: [
      ConsultaAcuerdoDetalleComponent,
      ConsultaAcuerdoAcuerdoComponent,
      ConsultaAcuerdoGeneralComponent
    ]
})
export class AcuerdoModule {}
